import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Pliable API',
  content: `
Pliable exposes a set of APIs to interact with the platform. The docs below explain these features.

## Generate API credentials

If you are an account admin in Pliable, you can go to the user menu in the top right, choose **Manage Users** and then **API Tokens**. Click **Generate Token**, choose the "Builder" role and then save your credentials in a secure place.

### Retrieve an Access Token for your credentials

Using your account id and the \`client_id\` and \`client_secret\` you created in the previous step, you can obtain an access token with a POST to the following endpoint:

\`\`\`bash
curl -X POST "https://app.pliable.co/api/v1/ext/authenticate" \\
  -H "Content-Type: application/json" \\
  -d '{
    "account_id": "acme_co",
    "client_id": "XXXXX",
    "client_secret": "XXXX"
}'
\`\`\`

This call returns JSON that contains an \`access_token\` that you will use to access any further API calls.

## API Workflows

- [Uploading files via API](/docs/uploading-files-via-api)
- [Programmatic User Management](/docs/programmatic-user-management)
`,
};

export default doc;
